var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { STORES_PROP } from "../Props.js";
import ActionBase, { ACTION_TYPES } from "./ActionBase.js";
const PARENT_MODEL_PROP = Symbol("PARENT_MODEL_PROP"), CHILD_MODELS_PROP = Symbol("CHILD_MODELS_PROP"), CONTEXT_PROP = Symbol("CONTEXT_PROP");
class RemoveChildAction extends ActionBase {
  static get defaultConfig() {
    return {
      /**
       * Reference to a parent model a child model has been removed to.
       *
       * @prp {Core.data.Model}
       * @readonly
       * @default
       */
      parentModel: void 0,
      /**
       * Children models removed.
       *
       * @prp {Core.data.Model[]}
       * @readonly
       * @default
       */
      childModels: void 0,
      /**
       * Map having children models as keys and values containing previous parent
       * index at the parent.
       *
       * @prp {Object}
       * @readonly
       * @default
       */
      context: void 0,
      stores: void 0
    };
  }
  get type() {
    return ACTION_TYPES.REMOVE_CHILD;
  }
  get parentModel() {
    return this[PARENT_MODEL_PROP];
  }
  set parentModel(model) {
    this[PARENT_MODEL_PROP] = model;
  }
  get childModels() {
    return this[CHILD_MODELS_PROP];
  }
  set childModels(models) {
    this[CHILD_MODELS_PROP] = models.slice(0);
  }
  get context() {
    return this[CONTEXT_PROP];
  }
  set context(ctx) {
    this[CONTEXT_PROP] = ctx;
  }
  get stores() {
    return this[STORES_PROP];
  }
  set stores(stores) {
    this[STORES_PROP] = stores;
  }
  undo() {
    const { parentModel, context, childModels } = this;
    childModels.sort((lhs, rhs) => {
      const lhsIndex = context.get(lhs).parentIndex, rhsIndex = context.get(rhs).parentIndex;
      return lhsIndex - rhsIndex;
    });
    childModels.forEach((m) => {
      const ctx = context.get(m);
      parentModel.insertChild(m, ctx.parentIndex, void 0, { orderedParentIndex: ctx.orderedParentIndex });
    });
  }
  redo() {
    this.parentModel.removeChild(this.childModels);
  }
}
__publicField(RemoveChildAction, "$name", "RemoveChildAction");
RemoveChildAction._$name = "RemoveChildAction";
export {
  RemoveChildAction as default
};
